import Utils from "./Utils";
import downloadService from "@/services/download";

export default {
  data() {
    return {
      downloadURL: "",
    };
  },
  mixins: [Utils],
  methods: {
    checkFileExistanceAndDownload(filePath, fileName) {
      const vue = this;
      return downloadService
        .checkDownloadToken(
          {
            filePath: String.raw`${filePath}`,
          },
          {
            headers: {
              Accept: "application/json",
            },
          }
        )
        .then(function(response) {
          if (response.success) {
            if (!fileName) {
              fileName = filePath
                .split("/")
                .pop()
                .split(".")
                .shift();
            }
            vue.download(response.data.token, fileName);
          } else {
            vue.callToaster(
              `${vue.$t('error-download')}: ${response.message}`
            );
          }
        })
        .catch(function(error) {
          vue.callToaster(vue.$t('error-download') +".");
          console.error(error);
        });
    },
    download(token, fileName) {
      const vue = this;
      downloadService
        .downloadFromToken(
          {
            token: token,
          },
          {
            headers: {
              Accept: "application/pdf",
            },
            responseType: "arraybuffer",
            dataType: "blob",
          }
        )
        .then(function(response) {
          // var data = window.atob(response.data);

          var blob = new Blob([response], {
            type: "application/pdf",
          });
          // var blob = response.data;

          if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              blob,
              "Document-Espace-Adv-Vitalliance.pdf"
            );
          } else {
            var url = window.URL.createObjectURL(blob);
            var a = document.createElement("a");
            a.href = url;
            a.download = fileName + ".pdf";
            document.body.appendChild(a);
            a.click();
          }
        })
        .catch(function(error) {
          // handle error
          vue.callToaster(vue.$t('error-download') +".");
          console.error(error);
        });
    },
  },
};
